import { useState } from "react";
import { toast } from "react-toastify";
import { getDriverByPhone, addPackages } from "../../api/services";
import LoadingModalComponent from "../../modals/loading-modal";
import AddDriverModal from "../../modals/add-driver-modal";
import UnregisteredDriverModal from "../../modals/unregistered-driver-modal";

export default function PackageRegisterScreen() {
  const initialValues = { phone: "", code: 1845, amount: 5000, profit: 1000, location: "" };

  const [driver, setDriver] = useState({});
  const [phoneInput, setPhoneInput] = useState(null);
  const [packages, setPackages] = useState([initialValues]);
  const [showAddDriverModal, setShowAddDriverModal] = useState(false);
  const [unregisteredModal, setUnregisteredModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);

  const addRow = () => setPackages((prev) => [...prev, initialValues]);

  const removeRow = (index) =>
    setPackages((prev) => prev.filter((_, i) => i !== index));

  const onDriverChange = async (e) => {
    const phone = e.target.value;
    if (phone.length === 8) {
      setPhoneInput(phone);
      try {
        setLoading(true);
        const res = await getDriverByPhone(phone);
        if (res.data) {
          setDriver(res.data);
        } else {
          setDriver({});
          setUnregisteredModal(true);
        }
      } catch {
        setDriver({});
        setUnregisteredModal(true);
      } finally {
        setLoading(false);
      }
    } else {
      setDriver({});
    }
  };

  const onPostChange = (e, i, type) => {
    setPackages((prev) => {
      const next = [...prev];
      next[i] = { ...next[i], [type]: e.target.value };
      return next;
    });
  };

  const onClickSave = async () => {
    try {
      setAdding(true);
      const res = await addPackages({ driverPhone: driver.phone, packages: JSON.stringify(packages) });
      if (res.data.success) {
        toast.success("Амжилттай бүртгэлээ");
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="card">
      <LoadingModalComponent show={loading || adding} />
      <AddDriverModal
        phone={phoneInput}
        show={showAddDriverModal}
        onHide={() => setShowAddDriverModal(false)}
        setShow={setShowAddDriverModal}
      />
      <UnregisteredDriverModal
        phone={phoneInput}
        show={unregisteredModal}
        onHide={() => setUnregisteredModal(false)}
        setShow={setUnregisteredModal}
        onSubmit={() => { setUnregisteredModal(false); setShowAddDriverModal(true); }}
      />
      <div className="card-body">
        <form>
          <p className="text-center rounded text-uppercase">Жолоочийн мэдээлэл</p>
          <div className="row gx-2 bg-light p-3 rounded">
            <div className="col-md-3">
              <label className="form-label">Утасны дугаар</label>
              <input type="phone" className="form-control" maxLength={8} onChange={onDriverChange} defaultValue={driver.phone} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Машины дугаар</label>
              <input readOnly type="text" className="form-control" placeholder={driver.car_num} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Тэмдэглэл</label>
              <input readOnly type="text" className="form-control" placeholder={driver.add_info} />
            </div>
          </div>
          <p className="p-1 text-center text-uppercase mt-2">Дайврын мэдээлэл</p>
          <div className="table-responsive">
            <table className="table table-centered table-bordered mb-0">
              <thead>
                <tr className="text-center">
                  <th style={{ width: 20 }} className="fw-normal">#</th>
                  <th className="fw-normal">Утас-1</th>
                  <th className="fw-normal">Утас-2</th>
                  <th className="fw-normal">Дайвар</th>
                  <th className="fw-normal">Хадгалалт</th>
                  <th className="fw-normal">Байршил</th>
                  <th style={{ width: 25 }} className="fw-normal"></th>
                </tr>
              </thead>
              <tbody>
                {packages.map((k, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td><input type="tel" className="form-control" maxLength={8} onChange={(e) => onPostChange(e, i, "phone")} /></td>
                    <td><input type="tel" className="form-control" maxLength={8} onChange={(e) => onPostChange(e, i, "phone1")} /></td>
                    <td><input type="number" className="form-control" placeholder={k.amount} onChange={(e) => onPostChange(e, i, "amount")} /></td>
                    <td><input type="number" className="form-control" placeholder={k.profit} onChange={(e) => onPostChange(e, i, "profit")} /></td>
                    <td><input type="search" className="form-control" placeholder={k.location} onChange={(e) => onPostChange(e, i, "location")} /></td>
                    <td>
                      <a style={{ cursor: "pointer" }} className="action-icon" onClick={() => removeRow(i)}>
                        <i className="ri-delete-bin-line" />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-center mt-2">
              <div className="btn border" onClick={addRow}>
                <i className="uil-plus-circle me-2"></i>Мөр нэмэх
              </div>
            </div>
          </div>
          <div className="row text-end mt-3">
            <div className="col-sm-12">
              <button className="btn btn-success" type="button" onClick={onClickSave}>
                <i className="ri-mail-send-line me-2"></i>
                <span>Хадгалах</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
